module.exports = __webpack_public_path__ + "img/sulv_6.3245246d.jpg";